module.exports = __webpack_public_path__ + "img/blibli-info-adding-store.6a238a32.webp";